import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';

const CustomPortal = ({children, domSelector, className = '', element = 'div'}) => {
  if (!domSelector) {
    return null;
  }
  const domNode = document.querySelector(domSelector);

  const [container] = React.useState(() => {
    const el = document.createElement(element);
    if (className) {
      el.classList.add(className);
    }
    return el;
  });

  useEffect(() => {
    domNode.appendChild(container);
    return () => {
      domNode.removeChild(container);
    };
  }, []);

  return createPortal(children, container);
};

export default CustomPortal;
